import React from 'react';

// Constants
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

// Utils
import { handleLaunchExternalLink } from 'Shared/utils/external-link';

// Components
import { WpContainer, WpContainerBody, WpContainerHeader } from 'Wpds/components/container';
import { WpIcon } from 'Wpds/components/icon';
import { WpButton } from 'Wpds/components/button';
import { WpLink } from 'Wpds/components/link';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

const Pi2AdminRedirectMessage = () => {
  return (
    <WpContainer>
      <WpContainerHeader>
        <h5>Employee Directory</h5>
      </WpContainerHeader>
      <WpContainerBody>
        <EmptyStateContainer
          subTitle={
            <>
              To view your organization’s employee directory or to upload org data, visit the main PI Administration
              page.&nbsp;&nbsp;
              <WpLink href={ExternalLinksConstants.pi_2_admin_employee_dirextory_documentation_link}>
                <WpIcon name="external-link" />
                View documentation
              </WpLink>
            </>
          }
          button={
            <WpButton
              onClick={() => handleLaunchExternalLink({ href: ExternalLinksConstants.pi_admin_employee_directory })}
              variant="primary"
            >
              <WpIcon name="external-link" />
              &nbsp; PI Administration
            </WpButton>
          }
        />
      </WpContainerBody>
    </WpContainer>
  );
};

export default Pi2AdminRedirectMessage;
